import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

function showGlobalError(label, err) {
  try {
    let bar = document.getElementById('__global_err_bar__');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = '__global_err_bar__';
      bar.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;background:#dc2626;color:#fff;font-family:monospace;font-size:12px;padding:10px 14px;white-space:pre-wrap;max-height:50vh;overflow:auto;box-shadow:0 2px 8px rgba(0,0,0,0.3)';
      bar.onclick = () => bar.remove();
      document.body.appendChild(bar);
    }
    const msg = err?.stack || err?.message || String(err);
    bar.textContent = `[${label}] ${msg}\n(tıklayınca kapanır)`;
  } catch (_) {}
}
window.addEventListener('error', (e) => showGlobalError('window.error', e.error || e.message));
window.addEventListener('unhandledrejection', (e) => showGlobalError('promise', e.reason));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
